<style lang="scss">
.el-menu--popup {
  z-index: 100;
  min-width: 150px !important;
  border: none;
  padding: 0 !important;
  border-radius: var(--el-border-radius-small);
  box-shadow: var(--el-box-shadow-light);
}

.head-container {
  overflow: hidden;
  height: 100vh;
  background-color: #000000;

}

.head-logo {
  .logo-img {
    width: 130px;
  }
}

* {
  --el-menu-hover-bg-color: rgb(30, 120, 255);
}
</style>
<template>
  <div class="head-container">
    <div class="head-logo" v-if="(isCollapse1 == 1 && isWindow)">
      <div @click="navigateTo('/')" style="margin: 0 auto;padding-top: 20px;width: fit-content;">
        <img src="@/assets/img/logo1_03.png" class="logo-img" />
      </div>
    </div>
    <div class="head-div" v-if="isCollapse1 != -1 || isWindow">
      <el-menu class="el-menu-vertical-demo"
        :collapse="(isCollapse1 == 0 && !isWindow) || (isCollapse1 == 0 && isWindow)" @open="handleOpen"
        @close="handleClose" style="border-right: none;height: 100%;width: 160px !important;width: fit-content;"
        active-text-color="#ffd04b" background-color="#000000" text-color="#fff" :default-active="defaultActive">>
        <el-sub-menu index="1">
          <template #title>
            <el-icon style="margin-right: 8px;"><span class="iconfont icon-shujuzhongxin1"
                style="font-size: 1.1rem !important;"></span></el-icon>
            <span>数据中心</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/console" @click="navigateTo('/console')">
              <span class="iconfont icon-shouye" style="font-size: 1.1rem !important;margin-right: 8px;"></span>控制台
            </el-menu-item>
            <el-menu-item @click="navigateTo('/userLog')" index="/userLog"><span class="iconfont icon-rizhi"
                style="font-size: 1.1rem !important;margin-right: 8px;"></span>用户日志
            </el-menu-item>
            <el-menu-item @click="navigateTo('/dockKey')" index="/dockKey"><span class="iconfont icon-jiekou"
                style="font-size: 1.1rem !important;margin-right: 8px;"></span>对接API
            </el-menu-item>
            <el-menu-item @click="navigateTo('/withdrawal')" index="/withdrawal"><span class="iconfont icon-tixian"
                style="font-size: 1.1rem !important;margin-right: 8px;"></span>提现记录</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
        <!-- 我的小店 -->
        <el-sub-menu index="8">
          <template #title>
            <el-icon style="margin-right: 8px;">
              <Shop />
            </el-icon>
            <span>我的小店</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/shopInfo" @click="navigateTo('/shopInfo')">
              <el-icon style="margin-right: 8px;">
                <Setting />
              </el-icon>
              小店信息
            </el-menu-item>
            <el-menu-item index="/payChannel" @click="navigateTo('/payChannel')">
              <el-icon style="margin-right: 8px;">
                <Wallet />
              </el-icon>
              支付通道
            </el-menu-item>
            <el-menu-item index="/orderManage" @click="navigateTo('/orderManage')">
              <el-icon style="margin-right: 8px;">
                <List />
              </el-icon>
              订单管理
            </el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
        <el-menu-item index="/agentEmpower" @click="navigateTo('/agentEmpower')">
          <el-icon style="margin-right: 8px;"> <span class="iconfont icon-dailishang-1"></span></el-icon>
          <template #title>代理中心</template>
        </el-menu-item>
        <el-menu-item index="/userManage" v-if="user_conf.uid == 1000" @click="navigateTo('/userManage')">
          <el-icon style="margin-right: 8px;"> <span class="iconfont icon-dailishang-1"></span></el-icon>
          <template #title>用户管理</template>
        </el-menu-item>
        <el-menu-item index="/admin/withdrawal" v-if="user_conf.uid == 1000" @click="navigateTo('/admin/withdrawal')">
          <el-icon style="margin-right: 8px;"> <span class="iconfont icon-tixian"></span></el-icon>
          <template #title>提现管理</template>
        </el-menu-item>
        <!-- <el-menu-item index="/includesList" @click="navigateTo('/includesList')">
          <el-icon><icon-menu /></el-icon>
          <template #title>软件列表</template>
        </el-menu-item> -->
        <el-sub-menu index="6" v-if="user_conf.uid == 1000">
          <template #title>
            <el-icon style="margin-right: 8px;"><span class="iconfont icon-kaifazhongxin-"
                style="font-size: 1.1rem !important;"></span></el-icon>
            <span>开发中心</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/develop" @click="navigateTo('/develop')">
              <span class="iconfont icon-shouye" style="font-size: 1.1rem !important;margin-right: 8px;">
              </span>数据概览
            </el-menu-item>
            <el-menu-item @click="navigateTo('/productManage')" index="/productManage"><span class="iconfont icon-rizhi"
                style="font-size: 1.1rem !important;margin-right: 8px;"></span>产品管理
            </el-menu-item>
            <el-menu-item @click="navigateTo('/versionLog')" index="/VersionLog"><span
                class="iconfont icon-banbenguanli" style="font-size: 1.1rem !important;margin-right: 8px;"></span>版本管理
            </el-menu-item>
            <el-menu-item @click="navigateTo('/NoticeManage')" index="/NoticeManage"><span class="iconfont icon-gonggao"
                style="font-size: 1.1rem !important;margin-right: 8px;"></span>公告管理
            </el-menu-item>
            <el-menu-item @click="navigateTo('/DataManage')" index="/DataManage"><span class="iconfont icon-gonggao"
                style="font-size: 1.1rem !important;margin-right: 8px;"></span>数据管理
            </el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
        <el-sub-menu index="7">
          <template #title>
            <el-icon style="margin-right: 8px;"><span class="iconfont icon-kamiguanli"
                style="font-size: 1.1rem !important;"></span></el-icon>
            <span>卡密管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/CarmineList" @click="navigateTo('/CarmineList')">
              <span class="iconfont icon-liebiao" style="font-size: 1.1rem !important;margin-right: 8px;">
              </span>卡密列表
            </el-menu-item>
            <el-menu-item @click="navigateTo('/CarmineUse')" index="/CarmineUse"><span class="iconfont icon-kamiguanli1"
                style="font-size: 1.1rem !important;margin-right: 8px;"></span>使用卡密
            </el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
        <el-menu-item index="/freeBenefits" @click="navigateTo('/freeBenefits')">
          <el-icon style="margin-right: 8px;"> <span class="iconfont icon-lingquguanggao"></span></el-icon>
          <template #title>免费授权</template>
        </el-menu-item>
        <el-menu-item index="/query" @click="navigateTo('/query')">
          <el-icon style="margin-right: 8px;"> <span class="iconfont icon-chaxun"></span></el-icon>
          <template #title>授权查询</template>
        </el-menu-item>
        <el-menu-item index="10" @click="openDialog('消息', '您确认要退出登录吗', true, 'outLogin')">
          <!-- <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-tuichu"></use>
        </svg> -->
          <span class="iconfont icon-tuichu1" style="margin-right: 7px;margin-left: 3px;"></span>
          <template #title>退出登录</template>
        </el-menu-item>
      </el-menu>
      <el-dialog v-model="centerDialog.isShow" :title="centerDialog.title" width="500" align-center>
        <span>{{ centerDialog.content }}</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialog.isShow = false">关闭</el-button>
            <el-button type="primary" @click="centerDialogClick(centerDialog.clickBind)">
              确认
            </el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<style scoped>
.router-link {
  text-decoration: none;
  color: inherit;
}

.head-div {
  height: 90vh;
  width: fit-content;
  overflow-y: auto;
  padding-top: 1rem;
  background-color: #000000;
}

.head-div ul {
  height: 90vh;
  overflow-y: auto;
}

.head-div ul::-webkit-scrollbar {
  display: none;
}

/* 滚动条的拖动滑块 */
.head-div ul::-webkit-scrollbar-thumb {
  background: #ffffff;
  /* 滑块背景颜色 */
  border-radius: 5px;
  /* 滑块圆角 */
}

.head-div ul::-webkit-scrollbar-track {
  background: transparent;
  /* 轨道背景颜色 */
}

.nav-el-radio {
  position: absolute;
  top: 1rem;
  left: 1.4rem;
  width: fit-content;
  color: white;
  font-weight: bold;
}
</style>
<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import {
  Document,
  Menu as IconMenu,
  Location,
  Shop,
  Setting,
  Wallet,
  List,
} from '@element-plus/icons-vue';
import axios from 'axios';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import { ElMessage, ElNotification } from 'element-plus'
import { useRouter } from 'vue-router';
import { mapState, useStore } from 'vuex';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  name: 'NavigationBar',
  components: {
    // IconMenu,
    Shop,
    Setting,
    Wallet,
    List,
  },
  computed: {
    ...mapState(['isCollapse']),
  },
  setup() {
    const store = useStore();
    const defaultActive = location.pathname.split("?")[0];
    var isWindow = window.innerWidth > 768;
    var isCollapse1 = ref(store.getters.isCollapse);
    // 监听 Vuex store 中 isCollapse 的变化
    watch(() => store.getters.isCollapse, (newValue: boolean) => {
      isCollapse1.value = newValue;
    });
    const router = useRouter();
    const navigateTo = (path: string) => {
      store.dispatch('setIsCollapse', isCollapse1.value);
      router.push(path);
    }
    const actions = {
      handleOpen: (key: string, keyPath: string[]) => {
        // console.log(key, keyPath);
      },
      handleClose: (key: string, keyPath: string[]) => {
        // console.log(key, keyPath);
      },
    };
    const user_conf = ref(JSON.parse(localStorage.getItem("user_conf") || "{}"));
    const outLogin = () => {
      localStorage.removeItem("token");
      ElMessage.success("退出登录成功")
      setTimeout(() => {
        location.reload();
      }, 1000);
    }
    var centerDialog = ref({
      isShow: false,
      title: "info",
      content: "content",
      clickBind: ""
    })
    const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
      if (isShow == false) {
        centerDialog.value.isShow = false
      }
      else {
        centerDialog.value.title = title
        centerDialog.value.content = content
        centerDialog.value.isShow = true
        centerDialog.value.clickBind = clickBind
      }
    }
    const centerDialogClick = (act: string) => {
      switch (act) {
        case "outLogin":
          outLogin();
          break;
        default:
          break;
      }
    }
    const isLogin = () => {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      axios.get(baseURL + "/userApi/isLogin", { timeout: 30000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == -1) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          if (res.data.code == 0 && res.data.isDefault == true) {
            ElNotification({
              title: 'Info',
              message: '您的密码为默认的123456，为保证您的安全，请尽快设置密码',
              duration: 0,
              type: 'info',
            })
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
    }
    return {
      navigateTo,
      ...actions,
      isLogin,
      centerDialogClick,
      openDialog,
      centerDialog,
      outLogin,
      store,
      isCollapse1,
      isWindow,
      user_conf,
      defaultActive
    }
  }
}
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;

}

.el-menu-vertical-demo {
  margin-right: 0 !important;
  padding-right: 0 !important;
}
</style>
